import React, { Component } from 'react';
export default class reviewLabelBut extends Component {
	constructor(props) {
		super(props);
		this.state = {
            labelName: this.props.labelName,
            action: this.props.action,
            value:  this.props.id
        };
        this.changeActionLabel = this.changeActionLabel.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if(newProps.id !== this.props.id  ){
            this.setState({
                action: newProps.action
            })
        }
    }



    changeActionLabel(){
        this.setState({
            action: !this.state.action
        },()=>{
            this.props.submitReviewLabelData(this.props.id)
        })
    }

    render() {
        return (
            <span index={this.props.index} onClick={this.changeActionLabel} id={this.props.id} className={this.state.action ? "review-label-block review-label-action" : "review-label-block"  } >{this.props.labelName}</span>
        )
    }
}    


// WEBPACK FOOTER //
// ./src/components/review/review-label-but.js